import(/* webpackMode: "eager", webpackExports: ["AppLayoutClient"] */ "/home/rajat/Downloads/HR Shakti/frontend/src/app/(app)/app-layout-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NotificationIntegrationWrapper"] */ "/home/rajat/Downloads/HR Shakti/frontend/src/components/layout/notification-integration-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Sidebar"] */ "/home/rajat/Downloads/HR Shakti/frontend/src/components/layout/sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WorkspaceHeader"] */ "/home/rajat/Downloads/HR Shakti/frontend/src/components/layout/workspace-header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/home/rajat/Downloads/HR Shakti/frontend/src/providers/auth-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RealtimeProvider"] */ "/home/rajat/Downloads/HR Shakti/frontend/src/providers/realtime-provider.tsx");
